export default __webpack_public_path__ + "static/schauinsland-reisen_1_1_de-1ad7abd46cda444ac94c2a00687eccc7.jpg";